import { Component, OnInit } from '@angular/core';
import {AdminBookSelectionListService} from './admin-book-selection-list.service';

@Component({
  selector: 'app-admin-book-selection-list',
  templateUrl: './admin-book-selection-list.component.html',
  styleUrls: ['./admin-book-selection-list.component.css']
})
export class AdminBookSelectionListComponent implements OnInit {

  constructor(public selectionSv: AdminBookSelectionListService) { }

  ngOnInit() {
  }

}
